module.exports = __webpack_public_path__ + "static/img/HUAWEI ADS 系统.4205a85c.png";